module.exports = __webpack_public_path__ + "img/ski_train1.749beb50.png";